import React, { createContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { NavItem, navItems } from "../../navigation/NavItems";

interface NavigationContextType {
  activeNavItem: NavItem;
  setActiveNavItem: (navItem: NavItem) => void;
}

export const NavigationContext = createContext<NavigationContextType>({
  activeNavItem: navItems[0],
  setActiveNavItem: () => 0,
});

export const NavigationProvider: React.FC = (props) => {
  const history = useHistory();
  const [activeNavItem, setActiveNavItem] = useState<NavItem>(navItems[0]);

  useEffect(() => {
    const currentLocation = history.location.pathname;
    const currentNavItem = navItems.find(
      (navItem) => navItem.url === currentLocation
    );
    setActiveNavItem(currentNavItem || navItems[0]);
  }, []);

  return (
    <NavigationContext.Provider
      value={{
        activeNavItem,
        setActiveNavItem,
      }}
    >
      {props.children}
    </NavigationContext.Provider>
  );
};

export default NavigationContext;
